<template>
  <span
    class="btnGoback"
    :style="`float:${float}`"
    @click="type === 'return' ? $router.go(-1) : handleClose()"
    ><i v-if="type === 'return'" class="icon_arrow_left"></i
    >{{ type === "return" ? "返回" : "关闭" }}</span
  >
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "return"
    },
    float: {
      type: String,
      default: "right"
    }
  },
  methods: {
    handleClose() {
      window.opener = null;
      window.open("about:blank", "_top").close();
    }
  }
};
</script>

<style>
.btnGoback {
  float: right;
  color: #8d8d8d;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
}
.icon_arrow_left {
  display: inline-block;
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png")
    no-repeat;
  width: 10px;
  height: 17px;
  background-size: cover;
  margin-right: 12px;
  position: relative;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Back.vue